import {createAction} from 'redux-act';

export const fetchBudgetList = createAction('Fetch user budget Income & Expense data')
export const fetchBudgetListSuccessful = createAction('Fetch user budget Income & Expense data Success')
export const fetchBudgetListFailure = createAction('Fetch user budget Income & Expense data Fail')

export const addNewBudgetTransaction = createAction('Add New Income or Expense data')
export const addNewBudgetTransactionSuccessful = createAction('Add New Income or Expense data Success')
export const addNewBudgetTransactionFailure = createAction('Add New Income or Expense data Fail')


export const updateTheBudgetTransaction = createAction('Update the budget data from DB')
export const updateTheBudgetTransactionSuccessful = createAction('Update the budget data Success')
export const updateTheBudgetTransactionFailure = createAction('Update the budget data Fail')


export const deleteTheBudgetTransaction = createAction('Delete the budget data from DB')
export const deleteTheBudgetTransactionSuccessful = createAction('Delete the budget data Success')
export const deleteTheBudgetTransactionFailure = createAction('Delete the budget data Fail')

export const getGraphDataOfSelectedPeriod = createAction('Get Calculated Graph Data of Selected Period')
export const getGraphDataOfSelectedPeriodSuccessful = createAction('Get Calculated Graph Data of Selected Period Success')
export const getGraphDataOfSelectedPeriodFailure = createAction('Get Calculated Graph Data of Selected Period Fail')

export const getTotalBudgetSummarize = createAction('Get Total Budget Summarize')
export const getTotalBudgetSummarizeSuccessful = createAction('Get Total Budget Summarize Success')
export const getTotalBudgetSummarizeFailure = createAction('Get Total Budget Summarize Fail')

export const updateCurrency = createAction('Update Currency')
export const updateCurrencySuccessful = createAction('Update Currency Success')
export const updateCurrencyFailure = createAction('Update Currency Fail')
